import { combineActions, handleActions } from 'redux-actions';
import { httpActions } from '@figure/frontlib-onboarding-redux';
import { GET_ELIGIBLE_STATES } from 'actions/eligible-states-actions';
import { payloadError } from './util';

const { SUCCESS, REQUEST, FAILURE } = httpActions;

export const initialState = {
  eligibleStates: [],
  loading: false,
  error: '',
};

const reducer = handleActions(
  {
    [combineActions(`${GET_ELIGIBLE_STATES}_${REQUEST}`)](state = initialState) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },
    [combineActions(`${GET_ELIGIBLE_STATES}_${FAILURE}`)](state, action) {
      return {
        ...state,
        loading: false,
        error: payloadError(action),
      };
    },
    [combineActions(`${GET_ELIGIBLE_STATES}_${SUCCESS}`)](state, action) {
      return {
        ...state,
        eligibleStates: action.payload,
        loading: false,
        error: '',
      };
    },
  },
  initialState
);

export default reducer;
